import { render } from "./ScheduleLecture.vue?vue&type=template&id=414a0708&scoped=true"
import script from "./ScheduleLecture.vue?vue&type=script&lang=js"
export * from "./ScheduleLecture.vue?vue&type=script&lang=js"

import "./ScheduleLecture.vue?vue&type=style&index=0&id=414a0708&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414a0708"]])

export default __exports__